 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"404":"404","cadastro~dashboard_home~dashboard_invoices_list~dashboard_invoices_view~dashboard_orders_list~dashbo~f495b296":"cadastro~dashboard_home~dashboard_invoices_list~dashboard_invoices_view~dashboard_orders_list~dashbo~f495b296","cadastro~dashboard_insights_index~dashboard_invoices_list~dashboard_invoices_view~dashboard_orders_l~7bc67232":"cadastro~dashboard_insights_index~dashboard_invoices_list~dashboard_invoices_view~dashboard_orders_l~7bc67232","cadastro~dashboard_insights_index~dashboard_products_addvideo~dashboard_settings":"cadastro~dashboard_insights_index~dashboard_products_addvideo~dashboard_settings","cadastro":"cadastro","dashboard_home~dashboard_insights_index~dashboard_invoices_list~dashboard_invoices_view~dashboard_or~ed8a40a6":"dashboard_home~dashboard_insights_index~dashboard_invoices_list~dashboard_invoices_view~dashboard_or~ed8a40a6","dashboard_products_addvideo":"dashboard_products_addvideo","dashboard_insights_index~dashboard_invoices_list~dashboard_invoices_view~dashboard_orders_list~dashb~d2db24a2":"dashboard_insights_index~dashboard_invoices_list~dashboard_invoices_view~dashboard_orders_list~dashb~d2db24a2","dashboard_invoices_list":"dashboard_invoices_list","dashboard_invoices_view":"dashboard_invoices_view","dashboard_orders_list":"dashboard_orders_list","dashboard_payment_cart":"dashboard_payment_cart","dashboard_products_add":"dashboard_products_add","dashboard_reports_platform":"dashboard_reports_platform","dashboard_works_addedit":"dashboard_works_addedit","login":"login","resetpassword":"resetpassword","resetpasswordchange":"resetpasswordchange","dashboard_home~dashboard_payment~dashboard_products":"dashboard_home~dashboard_payment~dashboard_products","dashboard_home":"dashboard_home","dashboard_payment":"dashboard_payment","dashboard_products":"dashboard_products","dashboard_reports_index":"dashboard_reports_index","emailverify":"emailverify","dashboard_insights_index":"dashboard_insights_index","dashboard_settings":"dashboard_settings","dashboard_products_isrc~dashboard_works_list":"dashboard_products_isrc~dashboard_works_list","dashboard_products_isrc":"dashboard_products_isrc","dashboard_works_list":"dashboard_works_list","dashboard_proructs_list":"dashboard_proructs_list","dashboard_insights":"dashboard_insights","dashboard_invoices":"dashboard_invoices","dashboard_orders":"dashboard_orders","dashboard_reports":"dashboard_reports","dashboard_works":"dashboard_works"}[chunkId]||chunkId) + "." + {"404":"c513b139","cadastro~dashboard_home~dashboard_invoices_list~dashboard_invoices_view~dashboard_orders_list~dashbo~f495b296":"b44b795d","cadastro~dashboard_insights_index~dashboard_invoices_list~dashboard_invoices_view~dashboard_orders_l~7bc67232":"b318618f","cadastro~dashboard_insights_index~dashboard_products_addvideo~dashboard_settings":"0fc7fb98","cadastro":"79bad2e5","dashboard_home~dashboard_insights_index~dashboard_invoices_list~dashboard_invoices_view~dashboard_or~ed8a40a6":"fa801634","dashboard_products_addvideo":"193c49e4","dashboard_insights_index~dashboard_invoices_list~dashboard_invoices_view~dashboard_orders_list~dashb~d2db24a2":"5e055b2d","dashboard_invoices_list":"7c99e690","dashboard_invoices_view":"270dbd90","dashboard_orders_list":"2d39c764","dashboard_payment_cart":"b32cc533","dashboard_products_add":"811dc817","dashboard_reports_platform":"3bfdca89","dashboard_works_addedit":"f5804480","login":"3e207ccc","resetpassword":"37ed58ba","resetpasswordchange":"c700ec17","dashboard_home~dashboard_payment~dashboard_products":"f735731f","dashboard_home":"571e25ea","dashboard_payment":"a91892e3","dashboard_products":"8264febf","dashboard_reports_index":"02d13328","emailverify":"a9ea51ce","dashboard_insights_index":"9f4dfa8b","dashboard_settings":"672a6c8c","dashboard_products_isrc~dashboard_works_list":"a404c9ae","dashboard_products_isrc":"2b0443e1","dashboard_works_list":"5161b41e","dashboard_proructs_list":"897d1dde","dashboard_insights":"c0a6b8cf","dashboard_invoices":"701257f9","dashboard_orders":"d5988bfe","dashboard_reports":"de342ed9","dashboard_works":"adf971ca"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"cadastro~dashboard_home~dashboard_invoices_list~dashboard_invoices_view~dashboard_orders_list~dashbo~f495b296":1,"cadastro~dashboard_insights_index~dashboard_invoices_list~dashboard_invoices_view~dashboard_orders_l~7bc67232":1,"cadastro~dashboard_insights_index~dashboard_products_addvideo~dashboard_settings":1,"cadastro":1,"dashboard_home~dashboard_insights_index~dashboard_invoices_list~dashboard_invoices_view~dashboard_or~ed8a40a6":1,"dashboard_products_addvideo":1,"dashboard_insights_index~dashboard_invoices_list~dashboard_invoices_view~dashboard_orders_list~dashb~d2db24a2":1,"dashboard_invoices_list":1,"dashboard_invoices_view":1,"dashboard_orders_list":1,"dashboard_payment_cart":1,"dashboard_products_add":1,"dashboard_reports_platform":1,"dashboard_works_addedit":1,"login":1,"resetpassword":1,"resetpasswordchange":1,"dashboard_home~dashboard_payment~dashboard_products":1,"dashboard_home":1,"dashboard_payment":1,"dashboard_products":1,"dashboard_reports_index":1,"emailverify":1,"dashboard_insights_index":1,"dashboard_settings":1,"dashboard_products_isrc~dashboard_works_list":1,"dashboard_products_isrc":1,"dashboard_works_list":1,"dashboard_proructs_list":1,"dashboard_invoices":1,"dashboard_orders":1,"dashboard_works":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"404":"404","cadastro~dashboard_home~dashboard_invoices_list~dashboard_invoices_view~dashboard_orders_list~dashbo~f495b296":"cadastro~dashboard_home~dashboard_invoices_list~dashboard_invoices_view~dashboard_orders_list~dashbo~f495b296","cadastro~dashboard_insights_index~dashboard_invoices_list~dashboard_invoices_view~dashboard_orders_l~7bc67232":"cadastro~dashboard_insights_index~dashboard_invoices_list~dashboard_invoices_view~dashboard_orders_l~7bc67232","cadastro~dashboard_insights_index~dashboard_products_addvideo~dashboard_settings":"cadastro~dashboard_insights_index~dashboard_products_addvideo~dashboard_settings","cadastro":"cadastro","dashboard_home~dashboard_insights_index~dashboard_invoices_list~dashboard_invoices_view~dashboard_or~ed8a40a6":"dashboard_home~dashboard_insights_index~dashboard_invoices_list~dashboard_invoices_view~dashboard_or~ed8a40a6","dashboard_products_addvideo":"dashboard_products_addvideo","dashboard_insights_index~dashboard_invoices_list~dashboard_invoices_view~dashboard_orders_list~dashb~d2db24a2":"dashboard_insights_index~dashboard_invoices_list~dashboard_invoices_view~dashboard_orders_list~dashb~d2db24a2","dashboard_invoices_list":"dashboard_invoices_list","dashboard_invoices_view":"dashboard_invoices_view","dashboard_orders_list":"dashboard_orders_list","dashboard_payment_cart":"dashboard_payment_cart","dashboard_products_add":"dashboard_products_add","dashboard_reports_platform":"dashboard_reports_platform","dashboard_works_addedit":"dashboard_works_addedit","login":"login","resetpassword":"resetpassword","resetpasswordchange":"resetpasswordchange","dashboard_home~dashboard_payment~dashboard_products":"dashboard_home~dashboard_payment~dashboard_products","dashboard_home":"dashboard_home","dashboard_payment":"dashboard_payment","dashboard_products":"dashboard_products","dashboard_reports_index":"dashboard_reports_index","emailverify":"emailverify","dashboard_insights_index":"dashboard_insights_index","dashboard_settings":"dashboard_settings","dashboard_products_isrc~dashboard_works_list":"dashboard_products_isrc~dashboard_works_list","dashboard_products_isrc":"dashboard_products_isrc","dashboard_works_list":"dashboard_works_list","dashboard_proructs_list":"dashboard_proructs_list","dashboard_insights":"dashboard_insights","dashboard_invoices":"dashboard_invoices","dashboard_orders":"dashboard_orders","dashboard_reports":"dashboard_reports","dashboard_works":"dashboard_works"}[chunkId]||chunkId) + "." + {"404":"31d6cfe0","cadastro~dashboard_home~dashboard_invoices_list~dashboard_invoices_view~dashboard_orders_list~dashbo~f495b296":"b334234b","cadastro~dashboard_insights_index~dashboard_invoices_list~dashboard_invoices_view~dashboard_orders_l~7bc67232":"69f17934","cadastro~dashboard_insights_index~dashboard_products_addvideo~dashboard_settings":"28f9dc69","cadastro":"fd207dbb","dashboard_home~dashboard_insights_index~dashboard_invoices_list~dashboard_invoices_view~dashboard_or~ed8a40a6":"fb29d7eb","dashboard_products_addvideo":"876bc636","dashboard_insights_index~dashboard_invoices_list~dashboard_invoices_view~dashboard_orders_list~dashb~d2db24a2":"7a0a9c2e","dashboard_invoices_list":"c3bc2816","dashboard_invoices_view":"36710e32","dashboard_orders_list":"36710e32","dashboard_payment_cart":"e3cbc401","dashboard_products_add":"e0eb88a6","dashboard_reports_platform":"90f4cdb3","dashboard_works_addedit":"4787a66a","login":"4c2b7a3a","resetpassword":"4c2b7a3a","resetpasswordchange":"4c2b7a3a","dashboard_home~dashboard_payment~dashboard_products":"8686da61","dashboard_home":"a3ab95ff","dashboard_payment":"8b98b775","dashboard_products":"c7315fda","dashboard_reports_index":"dd699765","emailverify":"4c2b7a3a","dashboard_insights_index":"71514469","dashboard_settings":"92ecc26f","dashboard_products_isrc~dashboard_works_list":"58d7ac7d","dashboard_products_isrc":"e46fb288","dashboard_works_list":"b334234b","dashboard_proructs_list":"f61d8bed","dashboard_insights":"31d6cfe0","dashboard_invoices":"fd020d09","dashboard_orders":"26131686","dashboard_reports":"31d6cfe0","dashboard_works":"48d0c90e"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
